<template>
  <v-card>
    <h1 class="text-pagename text-xs-center">Rider approve management</h1>
    <riderVeiws :riders="riders"></riderVeiws>
  </v-card>
</template>

<script>

import axios from "axios";
import { mapState } from "vuex";
import riderVeiws from "@/components/back-office/Rider/RiderApproveViews.vue";
export default {
  data: function() {
    return {};
  },
  components: {
    riderVeiws
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Rider",
        disabled: false,
        href:
           "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/riderinhouse"
        // href:
        //    "/weserve_admin_login/control/" +
        //   this.$route.params.province +
        //   "/rider/riderdashboard"
      },
      {
        text: "Rider approve",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  created() {
    // this.$store.dispatch('fetchRiderListBack/getRiderPendingList')
  },
  computed: {
    ...mapState({
      riders: state => state.fetchRiderListBack.riders_pending
    })
  }
};
</script>
